<template>
  <loading-overlay
    :active="isLoading"
    :is-full-page="true"
    :width="128"
    :height="128"
    loader="spinner"
    color="rgb(var(--color-active-hsl-128))"
    background-color="rgb(var(--color-b-back))"
  />

  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll
      :title="$t('settings.paragraph14')"
      target="/Settings"
      :hassubline="!isShrunk"
      :hasmenu="false"
      :isShrunk="isShrunk"
    >
      <template #icon>
        <IconPara14
          class="transition-all duration-300"
          :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"
        />
      </template>

      <template #subline>
        {{ $t('settings.settingsfor', { wallbox: decodeHtml($store.state.WbName) }) }}
      </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />


    <SettingsPanel class="mt-24 sm:mt-28 mb-3 sm:mb-4">
      <template #formgrid>
        <div class="mt-2 mb-2" :class="paramode ? '' : 'sm:col-span-2'">
          <ToggleWithLabel
            v-model="paramode"
            @update:model-value="onParaToggle"
            :label="$t('setpara14.paraonoff')"
            :ontext="$t('common.on')"
            :offtext="$t('common.off')"
            @update:modelValue ="onChange"
          />
        </div>

        <div v-if="paramode" class="mt-2 mb-2">
          <ToggleWithLabel
            v-model="parainvert"
            @update:model-value="onParaToggle"
            :label="$t('setpara14.parainvert')"
            :ontext="$t('common.on')"
            :offtext="$t('common.off')"
            @update:modelValue ="onChange"
          />
        </div>

        <div class="form-group sm:col-span-2">
          <label
            class="font-medium text-sm text-skin-b-list-mute"
            for="ActualParastatus"
          >
            {{ $t('setpara14.relaisstatus') }}
          </label>

          <input
            id="ActualParastatus"
            ref="ActualParastatus"
            name="ActualParastatus"
            type="text"
            disabled
            v-model="parastatus"
            class="form-control
              mt-1 block w-full px-3 py-2 rounded-lg
              font-semibold text-lg disabled:text-skin-b-list-mute
              border-2 border-skin-b-list-bord"
            :class="{
              'bg-skin-b-list-head': paravalue === 'off',
              'bg-green-100':
                (paravalue === 'p14' && relais === 1) ||
                (paravalue === 'p14inv' && relais === 0),
              'bg-orange-100':
                (paravalue === 'p14' && relais === 0) ||
                (paravalue === 'p14inv' && relais === 1),
            }"
            :placeholder="$t('setpara14.relaisstatus')"
            aria-describedby="ActualParastatus"
          />
        </div>

        <div class="form-group sm:col-span-2">
          <InputLabelError
            v-model="iostatus"
            :disabled="true"
            :label="$t('setpara14.iostatus')"
            :placeholder="$t('setpara14.relaisstatus')"
            @update:modelValue ="onChange"
          />
        </div>
      </template>

      <template #formbottom>
        <div class="w-full">
          <ActionButton  v-if="p14HasChanges || editmode" :disabled="isLoading || isSaving || !p14HasChanges" @click="savePara">
              {{ $t('common.save') }}
          </ActionButton>
        </div>
      </template>
    </SettingsPanel>

<div v-if="paramode" class="px-2 sm:px-4 w-full max-w-5xl">
      <!--Tabellenkopf-->
      <div :class="[ editmode ? 'bg-skin-active128/5' : 'bg-skin-b-list-head' ]"
        class="flex items-center mx-0 mt-4 sm:mt-6 border-2 border-skin-b-list-bord rounded-t-xl">
        <!-- Linker Bereich: Buttons -->
        <div class="flex items-center md:w-auto">
          <ButtonHeaderIcon v-if="editmode&&(filteredClients.length!=editcount)"
            @click="MarkForAll(true);" class="" :options="[]">
            <IconRadioChecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="editmode&&(filteredClients.length==editcount)"
            @click="MarkForAll(false);" class="" :options="[]">
            <IconRadioUnchecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="!editmode" tooltipText="" tooltipPosition="top-left"
          @click="stopPolling();editmode = !editmode;" class="" :options="[]">
            <!--<IconAddRfid class="w-12 h-12"/>-->
            <IconAdd class="w-10 h-10" />
          </ButtonHeaderIcon>

        </div>
        <!-- Mittlerer Bereich: Hauptbedienelemente -->
        <div class="flex-grow flex flex-col items-center w-full">
          <!-- Mittlerer Bereich: obere Zeile -->
          <div class="flex items-center border-b-2 w-full justify-between">
            <!-- 'ALLE AUSWÄHLEN' -->
            <ButtonHeader v-if="editmode&&(filteredClients.length!=editcount)"
              @click="MarkForAll(true);">
              <span class="sm:hidden">{{ $t('common.selectallmin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectall') }}</span>
            </ButtonHeader>
            <!-- 'KEINE AUSWÄHLEN' -->
            <ButtonHeader v-if="editmode&&(filteredClients.length==editcount)"
              @click="MarkForAll(false);">
              <span class="sm:hidden">{{ $t('common.selectnonemin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectnone') }}</span>
            </ButtonHeader>
            <!-- 'Status XX ausgewählt' -->
            <span v-if="editmode&&editcount>0"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ editcount }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('common.selected') }}</span>
            </span>
            <!-- 'ABBRRECHEN' -->
            <ButtonHeader v-if="editmode"
              @click="ResetMark();editmode = !editmode;startPolling();">
              {{ $t('common.cancel') }}
            </ButtonHeader>

            <!-- 'Status XX geregelt' -->
            <span  v-if="!editmode"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ p14count }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('seteasybalance.controlledloadpoints', p14count ) }}</span>
            </span>
            <!-- 'BEARBEITEN' -->
            <ButtonHeader v-if="!editmode"
              @click="stopPolling();editmode = !editmode; onChange();">
              <span>
                <IconRadioChecked class="sm:mr-1 w-6 h-6 sm:hidden" />
              </span>
              <span class="hidden sm:block">{{ $t('common.edit') }}</span>
            </ButtonHeader>

          </div>
          <!-- Mittlerer Bereich: Untere Zeile -->
          <div class="w-full flex items-center justify-between">
            <!-- Mobile Sorting RFID -->
            <NavSelectWithIcon v-model="sortlist"
              class="w-full flex-shrink sm:hidden"
              :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'nameup', label: $t('common.nameuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'namedown', label: $t('common.nameuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown', show: true },
                    { value: 'statusup', label: $t('common.status')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'statusdown', label: $t('common.status')+' ('+$t('common.descending')+')', icon: 'IconSortDown' ,show: true }
                  ]">
            </NavSelectWithIcon>
            <!-- Normal Sorting RFID -->
            <div
              class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
              <button
                @click="if(this.sortlist=='nameup') this.sortlist='namedown'; else this.sortlist='nameup';"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.name') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="this.sortlist=='nameup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="this.sortlist=='namedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!this.sortlist.includes('name')" />
              </button>
              
              <button
                @click="if(this.sortlist=='statusup') this.sortlist='statusdown'; else this.sortlist='statusup';"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.status') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="this.sortlist=='statusup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="this.sortlist=='statusdown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!this.sortlist.includes('status')" />
              </button>
              <!-- 
              <button @click="this.filterblocked=!this.filterblocked;filterpicker(this.filterboxid);"
                class="py-2 px-4 inline-flex text-skin-b-list-mute cursor-pointer focus:outline-none relative group uppercase">
                {{ $t('pairing.deactive') }}
                <IconRadioChecked class="ml-1 w-6 h-6" v-if="this.filterblocked" />
                <IconRadioUnchecked class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100" v-if="!this.filterblocked" />
              </button>

              <div class="hidden md:flex items-center w-48 text-skin-b-list-mute">
                <IconSearch v-if="searchfilter==''" @click="this.$refs.SearchFilterInput.focus();"
                  class="w-6 h-6 mr-1 hover:cursor-pointer flex-none" />
                <IconClose v-else
                  @click="this.searchfilter='';filterpicker(this.filterboxid);this.$refs.SearchFilterInput.focus();"
                  class="h-6 w-6 mr-1 hover:cursor-pointer flex-none" />
                <input class="shrink md:flex-1 w-full px-2 py-1 appearance-none 
                                  text-base leading-tight border-0 rounded
                                  bg-slate-300/20 focus:bg-slate-300/30
                                  focus:outline-none focus:ring-0"
                  :class="[ this.searchfilter=='' ? 'bg-slate-300/20 font-normal' : 'bg-slate-300/30 font-bold' ]"
                  type="text" ref="SearchFilterInput" :placeholder="$t('common.searchuppercase')" v-model="searchfilter"
                  @input="filterpicker(this.filterboxid);">
              </div> -->

            </div>

<!--
            <NavEditWithIcon v-if="editmode&&dlmClientsTemp.length>0"
              v-model="multieditselector" class="w-full flex-shrink" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'delete', label: $t('common.delete'), icon: 'delete', color:'red', show: true,
                      onClick: () => { deletemodal=true; }
                     },
                    { value: 'lock', label: $t('common.block'), icon: 'block', color:'red', show: true,
                      onClick: () => { switchstatus('multi','disabled'); }
                     },
                    { value: 'unlock', label: $t('common.activate'), icon: 'check', color:'green', show: true,
                      onClick: () => { switchstatus('multi','active'); }
                     },
                    { value: 'type', label: $t('common.changetype'), icon: 'stacks', show: true,
                      onClick: () => { multieditmodal=true; }
                     },
                    { value: 'color', label: $t('common.changecolor'), icon: 'color', show: true,
                      onClick: () => { multicolormodal=true; }
                     },
                  ]">
            </NavEditWithIcon>

            
                <div v-if="editmode.status&&editmode.tokenlist.length>0" class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
                  <ButtonHeader
                    @click="deletemodal=true;"
                  >
                    <span><IconDelete class="sm:mr-1 w-6 h-6"/></span>
                    <span class="hidden sm:block">{{ $t('common.delete') }}</span>
                  </ButtonHeader>
                </div>
                -->
            <div v-if="filteredClients.length > 0" class="flex-auto my-auto text-right">
              <h4 class="py-2 px-4 text-skin-b-list-mute">
                <span><strong>{{ filteredClients.length }}</strong>&nbsp;{{ $t('seteasybalance.loadpoint', filteredClients.length ) }}</span>
              </h4>
            </div>
          </div>
        </div>

      </div>
      <!--Tabellenkopf Ende-->

      <ListDynamicDiv>
        <ListBody :items="filteredClients" itemKey="serial" :isLoading="isLoading">
          <template #item="{ item }">

            <ListItemP14
              @listclick="handleP14Click(item)"
              :itemdata="item" :editmode="editmode" :buttonsvisible="false">
            </ListItemP14>

          </template>
        </ListBody>
      </ListDynamicDiv>    

    </div>

    
<!-- Check for Values  
    <p>this.localserial: {{ localserial }}</p><br>
    <p>this.p14Clients: {{ p14Clients }}</p><br>
    <p>this.p14ClientsTemp: {{ p14ClientsTemp }}</p><br>
    <p>this.allClients: {{ allClients }}</p><br>
    <p>settingsWallbox: {{ settingsWallbox }}</p><br>
    <p>statusWallbox: {{ statusWallbox }}</p><br>

    --> 

  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconPara14 from './icons/IconPara14.vue'
import IconAdd from './icons/IconAdd.vue'
import IconSort from './icons/IconSort.vue'
import IconSortUp from './icons/IconSortUp.vue'
import IconSortDown from './icons/IconSortDown.vue'
import IconRadioChecked from './icons/IconRadioChecked.vue'
import IconRadioUnchecked from './icons/IconRadioUnchecked.vue'
import SettingsPanel from './elements/SettingsPanel.vue'
import ListDynamicDiv from './elements/ListDynamicDiv.vue'
import ListBody from './elements/ListBody.vue'
import ListItemP14 from './elements/ListItemP14.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import NavSelectWithIcon from './elements/NavSelectWithIcon.vue'
import ButtonHeader from './elements/ButtonHeaderTooltip.vue'
import ButtonHeaderIcon from './elements/ButtonHeaderIconTooltip.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'


const TOKEN_EXPIRED = 'token';
const RESPONSE_OK = 'ok';
export default {
  name: 'Para14Settings',

  components: {
    SrcBackgroundScroll,
    HeadlineSubScroll,
    IconPara14,
    IconAdd, IconSort, IconSortUp, IconSortDown, IconRadioChecked, IconRadioUnchecked,
    SettingsPanel, ListDynamicDiv, ListBody, ListItemP14,
    ActionButton,
    InputLabelError,
    ToggleWithLabel, ButtonHeaderIcon, ButtonHeader,  NavSelectWithIcon, ConfirmLeaveModal
  },

  data() {
    return {
      isLoading: false,
      isSaving: false,

      saveto: this.$store.state.WbId,

      paravalue: 'off',
      paramode: false,
      parainvert: false,
      parastatus: '',
      relais: 0,
      iostatus: '',
      parasaved: false,
      statusWallbox: [],
      settingsWallbox: [],
      localserial: '',
      allClients: [],
      p14Clients: [],
      p14ClientsTemp: [],      
      editmode: false,
      sortlist: this.$store.state.SortListDlm,
      pollingInterval: null,

      isShrunk: false,

      isDirty:false,
      showLeaveDialog:false
    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
      p14HasChanges() {
      const settings = this.settingsWallbox ?? {};

      const serverMode = settings.in1 ?? 'off';
      const localMode  = this.paravalue;

      // differences
      const enabledDiff = serverMode !== localMode;

      // compare clients (by serial)
      const toKey = arr => (Array.isArray(arr) ? arr.map(x => String(x.serial).trim()).sort().join('|') : '');
      const clientsDiff = toKey(this.p14Clients) !== toKey(this.p14ClientsTemp);
      //console.log(settings,serverMode,localMode,enabledDiff,clientsDiff);

      return (enabledDiff || clientsDiff);
    },
    filteredClients() {
      const clients = Array.isArray(this.allClients) ? this.allClients : [];

      // editmode → zeige alle Clients
      let result = this.editmode
        ? clients
        : clients.filter(client => client?.isP14 === true);

      // ---------------------
      // Name Sorting
      // ---------------------
      if (this.sortlist === 'nameup') {
        result = result.slice().sort((a, b) =>
          String(a?.name ?? '').localeCompare(String(b?.name ?? ''), 'de', { sensitivity: 'base' })
        );
      }

      if (this.sortlist === 'namedown') {
        result = result.slice().sort((a, b) =>
          String(b?.name ?? '').localeCompare(String(a?.name ?? ''), 'de', { sensitivity: 'base' })
        );
      }

      // ---------------------
      // Status Sorting
      // ---------------------

      const STATUS_ORDER = {
        'loading': 0,
        'loading_paused': 1,
        'loading_done': 2,
        'wait_unlock': 3,
        'auth_ok': 4,
        'connected': 5,     
        'loading_planned': 7,
        'idle': 8,
        '': 9,
        'unknown': 10,
        'booting': 11,
        'no_connection': 12,        
        'error': 13,
      };

      const getStatusRank = status => STATUS_ORDER[status] ?? -1;

      if (this.sortlist === 'statusup') {
        // schlecht → gut
        result = result.slice().sort((a, b) =>
          getStatusRank(a?.wallboxStatus) - getStatusRank(b?.wallboxStatus)
        );
      }

      if (this.sortlist === 'statusdown') {
        // gut → schlecht
        result = result.slice().sort((a, b) =>
          getStatusRank(b?.wallboxStatus) - getStatusRank(a?.wallboxStatus)
        );
      }

      return result;
    },
    editcount() {
      return this.p14ClientsTemp?.length ?? 0;
    },
    p14count() {
      return this.p14Clients?.length ?? 0;
    },
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    decodeHtml(html) {
      if (!html) return ''
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      return txt.value
    },
    handleP14Click(item) {
      if (!this.editmode) return;
      if (item.isKing) return; // ⛔ block click if King

      item.isP14 = !item.isP14;
      this.MarkForP14(item.isP14, item.serial);
    },
    ResetMark() {
      this.p14ClientsTemp = [...this.p14Clients];

      // Create a fast lookup table of all serials in p14Clients
      const p14Serials = new Set(this.p14Clients.map(c => c.serial));

      // Mark all clients
      this.allClients.forEach(entry => {
        entry.isP14 = p14Serials.has(entry.serial);
      });
    },
    MarkForAll(selectAll) {

      if (selectAll) {
        // Add ALL non-king clients + always include local serial
        this.p14ClientsTemp = this.filteredClients
          .filter(entry => !entry.isKing)        // kings cannot be selected
          .map(entry => ({ serial: entry.serial }));

        // Ensure local serial is always included
        if (!this.p14ClientsTemp.some(c => c.serial === this.localserial)) {
          this.p14ClientsTemp.push({ serial: this.localserial });
        }

      } else {
        // Only keep local serial when unselecting all
        this.p14ClientsTemp = [{ serial: this.localserial }];
      }

      // UI consistency: update only non-king items
      this.filteredClients.forEach(entry => {
        if (!entry.isKing) {
          entry.isP14 = selectAll;
        }
      });
    },
    MarkForP14(checked, serialnr) {
      if (checked) {
        // Add only if not already in the list
        const exists = this.p14ClientsTemp.some(item => item.serial === serialnr);
        if (!exists) {
          this.p14ClientsTemp.push({ serial: serialnr });
        }
      } else {
        // Remove if it exists
        const index = this.p14ClientsTemp.findIndex(item => item.serial === serialnr);
        if (index > -1) {
          this.p14ClientsTemp.splice(index, 1);
        }
      }
    },
    onParaToggle() {
      this.updateParaValue()
      this.updateReduceStatus()
    },

    updateParaValue() {
      if(!this.p14Clients.some(c => c.serial === this.localserial))
        this.p14Clients.push({ serial: this.localserial });
      this.p14ClientsTemp = [...this.p14Clients];
      if (this.paramode && !this.parainvert) {
        this.paravalue = 'p14'
      } else if (this.paramode && this.parainvert) {
        this.paravalue = 'p14inv'
      } else {
        this.paravalue = 'off'
        this.p14Clients = []
        this.p14ClientsTemp = []
      }
    },

    updateReduceStatus() {
      if (this.paravalue === 'p14') {
        this.parastatus =
          this.relais === 1
            ? this.$t('setpara14.noreduce')
            : this.$t('setpara14.reduce')
      } else if (this.paravalue === 'p14inv') {
        this.parastatus =
          this.relais === 1
            ? this.$t('setpara14.reduce')
            : this.$t('setpara14.noreduce')
      } else {
        this.parastatus = this.$t('setpara14.reduceoff')
      }
    },

    async savePara() {
      this.isDirty=false;
      this.stopPolling();
      this.isSaving = true
      this.parasaved = false
      this.editmode = false
      const token = this.$store?.state?.token ?? '';
      const wbId  = this.$store?.state?.WbId ?? '';
      const p14Payload = JSON.stringify({ clients: this.p14ClientsTemp });

      const syncIoPortsUrl = `wallbox/settings.php?action=sync_io_ports&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}&in1=${encodeURIComponent(this.paravalue)}`;
      const syncP14ClientsUrl = `wallbox/settings.php?action=sync_p14&p14Clients=${encodeURIComponent(p14Payload)}&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;


      try {
        const [syncIoPortsResults, syncP14ClientsResults] = await Promise.allSettled([
          this.axios.get(syncIoPortsUrl),
          this.axios.get(syncP14ClientsUrl),
        ])

        // Save Sync IO Ports
        if (syncIoPortsResults.status === 'fulfilled') {
          const { data } = syncIoPortsResults.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            this.parasaved = true
            console.log('Sync IO Port saved')

          } else {
            console.error('Error save Sync IO Ports:', data);
          }
        } else {
          console.error('Sync IO Ports request failed:', syncIoPortsResults.reason);
        }

        // Save P14 Clients
        if (syncP14ClientsResults.status === 'fulfilled') {
          const { data } = syncP14ClientsResults.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            this.parasaved = true
            console.log('P14 Clients saved')

          } else {
            console.error('Error save P14 Clients:', data);
          }
        } else {
          console.error('Sync P14 Clients request failed:', syncP14ClientsResults.reason);
        }



      } catch (error) {
        console.error('saving P14 Clients IO Ports error:', error)
      } finally {
        this.isSaving = false
        this.loadInitialData();
      }
    },
    startPolling() {
      // clear any old interval just in case
      this.stopPolling();

      this.pollingInterval = setInterval(async () => {
        try {
          const token = this.$store?.state?.token ?? '';
          const wbId  = this.$store?.state?.WbId ?? '-1';

          const p14StatusUrl   = `wallbox/info.php?action=get_status&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;

          // Parallel requests for speed
          const [p14StatusResult] = await Promise.allSettled([
            this.axios.get(p14StatusUrl),
          ]);

          // --- Update DLM Status ---
          if (p14StatusResult.status === 'fulfilled') {
            const { data } = p14StatusResult.value || {};
            const status = data?.status;
            if (status === 'ok') {

              const tblStatus = data?.tbl_status || {}

              // Guard in case field is missing
              if (Object.prototype.hasOwnProperty.call(tblStatus, 'in1Powerd')) {
                this.relais = tblStatus.in1Powerd
              }

              this.iostatus =
                this.relais === 1
                  ? this.$t('setpara14.statusioon')
                  : this.$t('setpara14.statusiooff')

              // Update the status text and colors
              this.onParaToggle()

            }
          } else {
            console.error('Polling P14 status failed:', p14StatusResult.reason);
          }

        } catch (err) {
          console.error('Polling error:', err);
        }
      }, 2000); // every 2 seconds
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    async loadInitialData() {
      this.isLoading = true
      const token = this.$store?.state?.token ?? '';
      const wbId  = this.$store?.state?.WbId ?? '';

      const clientInfoUrl = `wallbox/client.php?action=client_info&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;
      const clientSettingsUrl = `wallbox/info.php?action=get_settings&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;
      const clientStatusUrl = `wallbox/info.php?action=get_status&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;
      const allClientsUrl  = `wallbox/client.php?action=reload_clients&user=${encodeURIComponent(token)}`;

      try {
        const [infoRes, settingsRes, statusRes, clientRes] = await Promise.allSettled([
          this.axios.get(clientInfoUrl),
          this.axios.get(clientSettingsUrl),
          this.axios.get(clientStatusUrl),
          this.axios.get(allClientsUrl),
        ])

        // --- Client info ---
        if (infoRes.status === 'fulfilled') {
          const { data } = infoRes.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            const clientinfo = data?.tbl_clientsettings ?? {};
            this.localserial = clientinfo.serial
            //console.log(this.localserial);
          } else {
            console.error('Error loading client info:', data);
          }
        } else {
          console.error('Client info request failed:', infoRes.reason);
        }

        // --- P14 settings ---
        if (settingsRes.status === 'fulfilled') {
          const { data } = settingsRes.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            const settings = data?.tbl_settings ?? {};
            this.settingsWallbox = settings
            this.paravalue = settings.in1

            this.p14Clients = Array.isArray(settings?.p14Clients?.clients)
              ? settings.p14Clients.clients
              : [];
            if(!this.p14Clients.some(c => c.serial === this.localserial))
              this.p14Clients.push({ serial: this.localserial });
            this.p14ClientsTemp = [...this.p14Clients];

            if (this.paravalue === 'p14') {
              this.paramode = true
              this.parainvert = false
            } else if (this.paravalue === 'p14inv') {
              this.paramode = true
              this.parainvert = true
            } else {
              this.paravalue = 'off'
              this.paramode = false
              this.parainvert = false
            }
          } else {
            console.error('Error loading P14 settings:', data);
          }
        } else {
          console.error('P14 settings request failed:', settingsRes.reason);
        }

        // P14 Status
        if (statusRes.status === 'fulfilled') {
          const { data } = statusRes.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            const p14status = data?.tbl_status ?? {};
            this.statusWallbox = p14status
            if (Object.prototype.hasOwnProperty.call(p14status, 'in1Powerd')) {
              this.relais = p14status.in1Powerd
            }
            this.iostatus =
            this.relais === 1
                ? this.$t('setpara14.statusioon')
                : this.$t('setpara14.statusiooff')

            // Ensure paravalue and status text are in sync
            this.onParaToggle()

          } else {
            console.error('Error loading P14 status:', data);
          }
        } else {
          console.error('P14 status request failed:', statusRes.reason);
        }

        // --- Clients ---
        if (clientRes.status === 'fulfilled') {
          this.processClients(clientRes.value?.data);
        } else {
          console.error('Clients request failed:', clientRes.reason);
        }

      } catch (error) {
        console.error('loadInitialData error:', error)
      } finally {
        this.isLoading = false;
        this.startPolling();
      }
    },
    processClients(data) {
      const status = data?.status;

      if (status === TOKEN_EXPIRED) {
        this.$router.push({ path: '/' });
        return;
      }

      if (status === RESPONSE_OK) {
        const safeNum = v => Number.isFinite(Number(v)) ? Number(v) : -Infinity;  
        this.allClients = (data?.tbl_clients ?? [])
          .map(client => ({
            ...client,
            name: this.decodeHtml?.(client?.name ?? '') ?? (client?.name ?? ''),
            info: this.decodeHtml?.(client?.info ?? '') ?? (client?.info ?? ''),
            isP14: this.p14Clients.some(c => c.serial === client.serial) || this.localserial === client.serial, // default; will be overwritten in updateIsDLM
            isKing: this.localserial === client.serial,
          }))
          // sort: groupId desc, then idx asc; tolerate missing values
          .sort((a, b) => {
            const g = safeNum(b?.groupId) - safeNum(a?.groupId);
            if (g !== 0) return g;
            return safeNum(a?.idx) - safeNum(b?.idx);
          });
      } else {
        console.error('Error fetching clients data:', data);
      }
    },


  },

  created() {
    this.loadInitialData()
  },
  beforeUnmount() {
    this.stopPolling();
    this.$store.commit('setSortListDlm', this.sortlist);
  },
}
</script>

<style src="@vueform/toggle/themes/default.css"></style>
<style scoped>
</style>
